import { render, staticRenderFns } from "./client-gift-noti.vue?vue&type=template&id=1e35342a&"
import script from "./client-gift-noti.vue?vue&type=script&lang=js&"
export * from "./client-gift-noti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports